import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import UkInvoiceForm from "./UKInvoice/components/UkInvoiceForm";
import IndianInvoiceForm from "./IndianInvoice/components/IndianInvoiceForm";
import TopNavigator from "./components/TopNavigator";

export default function App() {
  return (
    <BrowserRouter>
      <TopNavigator />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/indian-invoice" element={<IndianInvoiceForm />} />
        <Route path="/uk-invoice" element={<UkInvoiceForm />} />
      </Routes>
    </BrowserRouter>
  );
}
